export default __webpack_public_path__ + "neck.519380d4.png";